export const getBoostPlacementBaseStyles = () => ({
  placementCard: {
    border: '1px solid #c8c8c8',
    boxShadow: 'unset !important',
    borderRadius: '0px !important',
  },
  placementImageContainer: undefined,
  placementTextContainer: {
    fontSize: 10,
    lineHeight: '16px',
  },
  placementAdsLabel: undefined,
  placementGradient: undefined,
  placementShortHeadline: undefined,
  placementLongHeadline: undefined,
  placementFinalUrl: undefined,
  placementDescription: undefined,
  placementCallToAction: undefined,
  placementBusinessNameWithAdsLabel: undefined,
});

export const getBoostHeroImageCarouselStyles = (theme) => {
  // base styles
  const baseStyles = getBoostPlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
    },

    placementTextContainer: {
      position: 'absolute',
      maxWidth: '40%',
      minWidth: 100,
      top: '25%',
      left: '12%',
      padding: 15,
      borderRadius: 1,
      color: '#333',
      backgroundColor: 'rgba(255, 255, 255, 0.85)',
      fontSize: 10,
      lineHeight: '16px',
    },

    placementLongHeadline: {
      fontSize: 16,
      marginBottom: 4,
      fontWeight: 'bold',
    },

    placementDescription: {
    },

    placementCallToAction: {
      color: 'white',
      backgroundColor: '#0067b8',
      border: 'none',
      marginTop: 4,
    },
  };
};

export const getBoostWindowsSpotlight191x100Styles = (theme) => {
  // base styles
  const baseStyles = getBoostPlacementBaseStyles(theme);

  return {
    ...baseStyles,
    placementCard: {
      ...baseStyles.placementCard,
      /*
        todo: setting position and top/left here to make it look exactly same as
        current preview but setting loation of placement in this level is not a
        good idea, as it may limit the usage of this component in other places
      */
      position: 'absolute !important',
      margin: '0 !important',
      left: '50%',
      top: '45% !important',
      transform: 'translate(-50%, -50%)',
      width: '444x !important',
      height: '250px !important',

      '& .hardcode-time': {
        flexDirection: 'column',
        alignItems: 'center',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'space-between',
        top: 40,
        left: '50%',
        color: 'white',
        transform: 'translate(-50%)',
        lineHeight: '22px',
        '& .time': {
          fontSize: 30,
        },
        '& .date': {
          fontSize: 7,
          paddingLeft: 5,
        },
      },
    },
    placementTextContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: 12,
      left: 'unset',
      right: 10,
      bottom: 'unset',
      width: 130,
      height: 130,
      padding: 10,
      color: 'white',
      opacity: 0.8,
      fontSize: 8,
      lineHeight: '16px',
      borderRadius: 5,
      background: 'transparent',
    },
    placementCenterSection: {
      position: 'absolute',
      top: 118,
      left: 205,
      width: 60,
      fontSize: 14,
    },
    placementSearchIconCenter: {
      position: 'absolute',
      top: 0,
      left: 21,
      width: 18,
      height: 18,
    },
    placementHotspotsCenterSection: {
      color: 'white',
      fontSize: 5,
      textAlign: 'center',
      marginTop: 13,
      lineHeight: '5px',
    },
    placementTopRightSection: {
      position: 'absolute',
      top: 0,
      left: 25,
      width: 63,
    },
    placementCameraIcon: {
      position: 'absolute',
      top: 0,
      left: 20,
      width: 18,
      height: 18,
    },
    placementHeadlineTopRight: {
      color: 'white',
      fontSize: 5,
      textAlign: 'center',
      marginTop: 13,
      lineHeight: '5px',
    },
    placementTopLeftSection: {
      position: 'absolute',
      top: 0,
      left: -280,
      width: 60,
    },
    placementSearchIconTopLeft: {
      position: 'absolute',
      top: 0,
      left: 20,
      width: 18,
      height: 18,
    },
    placementHotspotsLeftSection: {
      color: 'white',
      fontSize: 5,
      textAlign: 'center',
      marginTop: 13,
      lineHeight: '5px',
    },
    placementWifiIcon: {
      position: 'absolute',
      top: 235,
      left: 410,
      width: 10,
      height: 10,
    },
    placementBatteryIcon: {
      position: 'absolute',
      top: 235,
      left: 425,
      width: 9,
      height: 9,
    },
  };
};

export const getBoostDiscoverCard1x1Styles = (theme) => {
  // base styles
  const baseStyles = getBoostPlacementBaseStyles(theme);

  return {
    ...baseStyles,
    placementCard: {
      ...baseStyles.placementCard,
      width: '288px !important',
      height: 424,
      borderRadius: '5px !important',

      '& .hardcode-discover': {
        position: 'absolute',
        top: 0,
        left: 0,
        color: 'rgb(50, 49, 48)',
        width: '100%',
        fontSize: 14,
        fontWeight: 600,
        paddingLeft: 10,
        borderBottom: '1px solid rgb(232, 232, 232)',
        padding: '12px 0px 12px 16px',
        lineHeight: 1.4,
      },
    },
    placementImageContainer: {
      position: 'absolute',
      top: 44,
      width: 256,
      height: 210,
      padding: '0px 24px',
      margin: '16px 16px 0px',
    },
    placementShortHeadline: {
      position: 'absolute',
      width: 256,
      top: 286,
      left: 16,
      color: 'black',
      fontSize: 16,
      fontWeight: 600,
      paddingBottom: 10,
    },
    placementDescription: {
      position: 'absolute',
      top: 314,
      left: 16,
      color: 'black',
      fontSize: 12,
      width: 256,
    },
    placementCallToAction: {
      position: 'absolute',
      top: 364,
      left: 16,
      border: 'none',
      padding: 0,
      fontSize: 12,
      borderRadius: 5,
      backgroundColor: 'transparent',
      height: 60,
    },
  };
};

export const getBoostStartMenuStyles = (theme) => {
  // base styles
  const baseStyles = getBoostPlacementBaseStyles(theme);

  return {
    ...baseStyles,
    placementCard: {
      ...baseStyles.placementCard,
      width: '244px !important',
      height: 68,
      backgroundColor: '#262632 !important',
    },
    placementLogoContainer: {
      position: 'absolute',
      top: 40,
      left: 4,
    },
    placementShortHeadline: {
      position: 'absolute',
      left: 4,
      top: 8,
      width: 236,
      height: 16,
      fontSize: 12,
      fontWeight: 400,
      color: 'white',
    },
    placementLongHeadline: {
      position: 'absolute',
      left: 40,
      top: 35,
      color: 'white',
      fontSize: 12,
      width: 204,
      height: 32,
    },
  };
};

export const getBoostActionStyles = (theme) => {
  // base styles
  const baseStyles = getBoostPlacementBaseStyles(theme);

  return {
    ...baseStyles,
    placementCard: {
      ...baseStyles.placementCard,
      width: '360px !important',
      height: 216,
      backgroundColor: '#e8e9eb !important',
      zIndex: 1,
    },
    placementLogoContainer: {
      position: 'absolute',
      top: 57,
      left: 35,
      width: 45,
      height: 45,
      zIndex: 3,
    },
    placementSuggestedContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      width: 360,
      height: 40,
    },
    placementVectorIcon: {
      position: 'absolute',
      color: 'black',
      width: 16,
      height: 16,
      top: 16,
      left: 117,
    },
    placementSuggestedText: {
      position: 'absolute',
      color: 'black',
      fontSize: 14,
      lineHeight: '16px',
      fontWeight: 600,
      width: 81,
      height: 20,
      top: 15,
      left: 135,
      textAlign: 'center',
    },
    placementDetailsContainer: {
      position: 'absolute',
      left: 16,
      top: 40,
      width: 328,
      height: 160,
      backgroundColor: 'white',
      zIndex: 2,
    },
    placementShortHeadline: {
      position: 'absolute',
      left: 90,
      top: 16,
      color: 'black',
      width: 191,
      height: 20,
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '20px',
      paddingBottom: 5,
      zIndex: 3,
    },
    placementDescription: {
      position: 'absolute',
      left: 90,
      top: 37,
      color: 'black',
      fontSize: 12,
      width: 191,
      height: 67,
      fontWeight: 400,
      lineHeight: '20px',
      zIndex: 3,
    },
    placementActionContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      position: 'absolute',
      top: 150,
      left: 28,
      width: 305,
      height: 30,
      // margin: '0 10px',
      gap: 7,
      zIndex: 3,
    },
    placementCallToAction: {
      color: 'black',
      width: 149,
      height: 30,
      border: '0.93px outset rgba(0, 0, 0, 0.0878)',
      borderRadius: '3.72px',
      boxShadow: 'rgba(0, 0, 0, 0.2622) 0.1px 0.53px 0.1px 0.1px',
      padding: '0.93px',
      backgroundColor: 'white',
    },
    placementDismissAction: {
      color: 'black',
      width: 149,
      height: 30,
      border: '0.93px outset rgba(0, 0, 0, 0.0878)',
      borderRadius: '3.72px',
      boxShadow: 'rgba(0, 0, 0, 0.2622) 0.1px 0.53px 0.1px 0.1px',
      padding: '0.93px',
      backgroundColor: 'white',
    },
  };
};

export const getBoostBannerStyles = (theme) => {
  // base styles
  const baseStyles = getBoostPlacementBaseStyles(theme);

  return {
    ...baseStyles,
    placementCard: {
      ...baseStyles.placementCard,
      width: '600px !important',
      height: 35,
    },
    placementLogoContainer: {
      position: 'absolute',
      top: '50%',
      left: 10,
      transform: 'translateY(-50%)',
    },
    placementShortHeadline: {
      position: 'absolute',
      top: '50%',
      left: 40,
      color: 'black',
      width: 220,
      fontSize: 12,
      transform: 'translateY(-50%)',
      paddingBottom: 5,
    },
    placementActionContainer: {
      display: 'flex',
      alignItems: 'center',
      position: 'absolute',
      top: 1,
      bottom: 0,
      right: 30,
    },
    placementCallToAction: {
      color: 'white',
      border: 'none',
      padding: '5px 10px',
      borderRadius: 10,
      backgroundColor: '#0078d4',
      marginRight: 10,
    },
    placementDismissAction: {
      color: 'black',
      border: 'none',
      padding: '5px 10px',
      borderRadius: 10,
    },
  };
};

export const getBoostProngFeed191x100Styles = (theme) => {
  // base styles
  const baseStyles = getBoostPlacementBaseStyles(theme);

  return {
    ...baseStyles,
    placementCard: {
      ...baseStyles.placementCard,
      width: '300px !important',
      height: 304,
      background: 'linear-gradient(140.53deg, #F5F7E1 9.32%, #CDF0FF 58.45%) !important',
      borderRadius: '8px !important',
      border: '1px solid rgba(0, 0, 0, 0.0578)',
      boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.04)',
    },
    placementImageContainer: {
      position: 'absolute',
      top: 48,
      left: 16,
      width: 268,
      height: 140,
    },
    placementLogoContainer: {
      position: 'absolute',
      top: 16,
      left: 16,
      width: 16,
      height: 16,
    },
    placementBusinessNameContainer: {
      position: 'absolute',
      top: 16,
      left: 40,
      width: 28,
      height: 20,
      color: 'rgba(26, 26, 26, 1) !important',
      padding: '0 !important',
    },
    placementLongHeadline: {
      position: 'absolute',
      width: '268px !important',
      top: 200,
      left: 16,
      height: 72,
      color: 'rgba(26, 26, 26, 1)',
      fontSize: 18,
      fontWeight: 600,
      lineHeight: '23.94px',
    },
    placementCallToAction: {
      position: 'absolute',
      top: 272,
      left: 106,
      width: 91,
      height: 24,
      fontSize: 12,
      fontWeight: 400,
      color: 'rgba(26, 26, 26, 1)',
      background: 'rgba(255, 255, 255, 0.46)',
      border: '1px solid',
      borderImageSource: 'linear-gradient(180deg, rgba(0, 0, 0, 0.0578) 90.58%, rgba(0, 0, 0, 0.1622) 100%)',
      borderRadius: '100px',
      marginTop: 4,
    },
    placementDotsIcon: {
      position: 'absolute',
      top: 10,
      right: 10,
      width: 28,
      height: 28,
    },
  };
};

export const getBoostCoachmark175x100Styles = (theme) => {
  // base styles
  const baseStyles = getBoostPlacementBaseStyles(theme);

  return {
    ...baseStyles,
    placementCard: {
      ...baseStyles.placementCard,
      width: '280px !important',
      height: 300,
    },
    placementShortHeadline: {
      position: 'absolute',
      top: 180,
      left: 20,
      right: 20,
      color: 'black',
      fontWeight: 'bold',
      fontSize: 20,
      paddingBottom: 5,
    },
    placementDescription: {
      position: 'absolute',
      top: 210,
      left: 20,
      color: 'black',
      fontSize: 20,
    },
    placementCallToAction: {
      position: 'absolute',
      top: 260,
      left: 20,
      fontSize: 15,
      color: 'white',
      border: 'none',
      padding: '8px',
      borderRadius: 5,
      backgroundColor: '#0078d4',
    },
  };
};

export const getBoostContentHubStyles = (theme) => {
  // base styles
  const baseStyles = getBoostPlacementBaseStyles(theme);

  return {
    ...baseStyles,
    placementCard: {
      ...baseStyles.placementCard,
      width: '369px !important',
      height: 101,
      padding: '6px',
      marginTop: '32%',
      background: '#fff',
      borderRadius: '4px !important',
      border: '0.5px solid var(--Neutral-Stroke-3-Rest, rgba(240, 240, 240, 1))',
      boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.04) !important',
      '& .placement-card-content': {
        display: 'flex',
        flexDirection: 'row-reverse !important',
      },
    },
    placementImageContainer: {
      width: 133,
      height: 100,
      marginLeft: 16,
      ...baseStyles.placementImageContainer,
    },
    placementTextContainer: {
      flexGrow: 1,
    },
    placementShortHeadline: {
      position: 'absolute',
      top: 20,
      left: 16,
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '18px',
      lineHeight: '20px',
      color: 'rgba(36, 36, 36,1)',
    },
    placementLongHeadline: {
      position: 'absolute',
      top: 40,
      left: 16,
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '9px',
      lineHeight: '13px',
      color: 'rgba(36, 36, 36,1)',
      paddingTop: 8,
      width: 222,
    },
    placementCallToAction: {
      position: 'absolute',
      top: 65,
      left: 12,
      fontFamily: 'Segoe UI',
      fontWeight: '800',
      fontSize: '9px',
      lineHeight: '16px',
      color: 'rgb(0, 120, 212)',
      border: 'none',
      background: 'none',
      paddingTop: 20,
    },
  };
};

export const getResponsiveBoostWindowsSpotlight191x100Styles = (theme) => {
  // base styles
  const baseStyles = getBoostWindowsSpotlight191x100Styles(theme);

  return baseStyles;
};

export const getResponsiveBoostMiniSpotlightStyles = (theme) => {
  // base styles
  const baseStyles = getBoostPlacementBaseStyles(theme);

  return {
    ...baseStyles,
    placementCard: {
      ...baseStyles.placementCard,
      /*
        todo: setting position and top/left here to make it look exactly same as
        current preview but setting loation of placement in this level is not a
        good idea, as it may limit the usage of this component in other places
      */
      position: 'absolute !important',
      margin: '0 !important',
      left: '50%',
      top: '45% !important',
      transform: 'translate(-50%, -50%)',
      width: '397x !important',
      height: '250px !important',

      '& .hardcode-time': {
        flexDirection: 'column',
        alignItems: 'center',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'space-between',
        top: 45,
        left: 242,
        color: 'white',
        transform: 'translate(-50%)',
        lineHeight: '22px',
        '& .time': {
          fontSize: 30,
        },
        '& .date': {
          fontSize: 7,
          paddingLeft: 5,
        },
      },
    },
    placementTextContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: 12,
      left: 'unset',
      right: 10,
      bottom: 'unset',
      width: 130,
      height: 130,
      padding: 10,
      color: 'white',
      opacity: 0.8,
      fontSize: 8,
      lineHeight: '16px',
      borderRadius: 5,
      background: 'transparent',
    },
    placementTopRightSection: {
      position: 'absolute',
      top: 0,
      left: 25,
      width: 60,
    },
    placementSearchIconTopRight: {
      position: 'absolute',
      top: 11,
      left: -14,
      width: 18,
      height: 18,
    },
    placementLongHeadline: {
      color: 'white',
      fontSize: 4,
      textAlign: 'center',
      marginTop: 13,
      lineHeight: '5px',
    },
    placementDescription: {
      color: 'white',
      fontSize: 4,
      textAlign: 'center',
      marginTop: 2,
      lineHeight: '5px',
    },
    placementWifiIcon: {
      position: 'absolute',
      top: 235,
      left: 410,
      width: 10,
      height: 10,
    },
    placementBatteryIcon: {
      position: 'absolute',
      top: 235,
      left: 425,
      width: 9,
      height: 9,
    },
  };
};
